<template>
  <div class="project-type-feature-header">
    <div class="color-shadow" :style="{ background: shadowColor }" />

    <v-img :src="illustration" class="illustration" />

    <div class="dialog-title">
      <slot name="title"></slot>
    </div>

    <!-- The host modal runs with hide-header, so the close button lives over the illustration -->
    <app-button
      type="icon"
      class="project-type-feature-header__close"
      data-locator="close-button"
      :aria-label="$t('common.close')"
      size="small"
      tabindex="-1"
      @click="$emit('close')"
    >
      <template #left-icon>
        <app-material-icon name="close_small" size="lg" />
      </template>
    </app-button>
  </div>
</template>

<script>
export default {
  name: 'ProjectTypeFeatureHeader',
  emits: ['close'],
  props: {
    shadowColor: {
      type: String,
      required: true,
    },
    illustration: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
// The colored shape and the title below are absolutely positioned, so this block has to be
// their containing block: otherwise they frame whichever ancestor happens to be positioned
.project-type-feature-header {
  position: relative;
  // No explicit width on purpose: it would be computed against the container content box,
  // and the negative margins below could no longer stretch the block to the card edges
  width: auto;
  // This header is always rendered at the top of an AppModal body, which is run with
  // hide-header. Cancelling the .v-card-text padding here rather than in every host lets
  // the illustration reach the card edges without each dialog restating it.
  margin: -4px -24px 24px;

  // Mirrors the AppModal header close button, since that header is hidden here
  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
    padding: 0 !important;
    border-radius: 50%;
    background-color: rgb(var(--v-theme-grey-50)) !important;

    &:hover:enabled {
      background-color: rgb(var(--v-theme-grey-100)) !important;
    }
  }
}

.illustration {
  max-height: 235px;

 :deep(img) {
    object-position: right center;
  }
}

.color-shadow {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  clip-path: polygon(55% 0, 100% 0, 100% 82%, 55% 0);
}

.dialog-title {
  position: absolute;
  bottom: 40px;
  left: 65px;
}

@media (max-width: 768px) {
  .dialog-title {
    left: 40px;
  }

  .illustration {
    max-height: 180px;
  }
}

@media (max-width: 660px) {
  .dialog-title {
    bottom: 26px;

    :deep(h1) {
      font-size: 20px !important;
    }
  }

  .illustration {
    max-height: 140px;
  }
}

@media (max-width: 570px) {
  .illustration {
    max-height: 100px;
  }
}
</style>
